import React, {Component} from "react";

class Audit extends Component
{
	render()
	{
		document.title = "DateNight: Audit";

		return (
			<div>
				<h2>Audit Trail</h2>
			</div>
		);
	}
}

export default Audit;



// WEBPACK FOOTER //
// ./src/components/Audit.js